import React from 'react';

const organizationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#9B9B9B"
        fillRule="nonzero"
        d="M20 13.75c0-.69-.56-1.25-1.25-1.25h-.833a.208.208 0 01-.209-.208V11.25a1.46 1.46 0 00-1.458-1.458h-4.167a.208.208 0 01-.208-.209V7.707c0-.114.094-.207.208-.207h1.667c.69 0 1.25-.56 1.25-1.25v-5C15 .56 14.44 0 13.75 0H7.917c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h2.5c.115 0 .208.093.208.208v1.875a.208.208 0 01-.208.209H3.75a1.46 1.46 0 00-1.458 1.458v1.042a.208.208 0 01-.209.208H1.25c-.69 0-1.25.56-1.25 1.25v5C0 19.44.56 20 1.25 20h5.833c.69 0 1.25-.56 1.25-1.25v-5c0-.69-.56-1.25-1.25-1.25H3.75a.208.208 0 01-.208-.208V11.25a.21.21 0 01.208-.208h12.5a.21.21 0 01.208.208v1.042a.208.208 0 01-.208.208h-3.333a1.25 1.25 0 00-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h5.833c.69 0 1.25-.56 1.25-1.25v-5zM9.583 3.54a.625.625 0 110-1.25h2.5a.625.625 0 110 1.25h-2.5zM2.917 14.79h2.5a.625.625 0 010 1.25h-2.5a.625.625 0 110-1.25zm14.166 0a.625.625 0 010 1.25h-2.5a.625.625 0 010-1.25h2.5z"
      ></path>
    </g>
  </svg>
);

export default organizationIcon;
